import { combine } from '@exodus/atoms';
import { ErrorCode } from '../atoms/exchange-availability.js';
export class ExchangeAvailabilityModule {
    #exchangeAvailabilityAtom;
    #geolocationAndAppProcessAtom;
    #subscriptions = [];
    constructor({ geolocationAtom, appProcessAtom, exchangeAvailabilityAtom, }) {
        this.#exchangeAvailabilityAtom = exchangeAvailabilityAtom;
        this.#geolocationAndAppProcessAtom = combine(appProcessAtom
            ? {
                geolocation: geolocationAtom,
                appProcess: appProcessAtom,
            }
            : {
                geolocation: geolocationAtom,
            });
    }
    load = () => {
        this.#subscriptions = [
            this.#geolocationAndAppProcessAtom.observe(this.#handlegeolocationAndAppProcessChange),
        ];
    };
    stop = () => {
        this.#subscriptions.forEach((unsubscribe) => unsubscribe());
        this.#subscriptions = [];
    };
    #handlegeolocationAndAppProcessChange = ({ geolocation, appProcess, }) => {
        if (!('isAllowed' in geolocation)) {
            return this.#exchangeAvailabilityAtom.set({
                isAvailable: false,
                reason: { code: ErrorCode.TemporarilyUnavailable },
            });
        }
        const { countryCode, countryName, regionCode, regionName, isAllowed } = geolocation;
        if (isAllowed) {
            return this.#exchangeAvailabilityAtom.set({
                isAvailable: true,
            });
        }
        if (countryCode === 'US' && regionName) {
            if (appProcess?.networkType === 'cellular' && regionCode) {
                return this.#exchangeAvailabilityAtom.set({
                    isAvailable: false,
                    reason: { code: ErrorCode.StateMaybeUnavailable, regionName, regionCode },
                });
            }
            return this.#exchangeAvailabilityAtom.set({
                isAvailable: false,
                reason: { code: ErrorCode.StateUnavailable, regionName },
            });
        }
        if (countryCode === 'UA' && regionCode === '43') {
            return this.#exchangeAvailabilityAtom.set({
                isAvailable: false,
                reason: { code: ErrorCode.RegionUnavailable, regionName },
            });
        }
        if (countryName) {
            return this.#exchangeAvailabilityAtom.set({
                isAvailable: false,
                reason: { code: ErrorCode.CountryUnavailable, countryName },
            });
        }
        void this.#exchangeAvailabilityAtom.set({
            isAvailable: false,
            reason: { code: ErrorCode.TemporarilyUnavailable },
        });
    };
}
const exchangeProvidersModuleFactory = (args) => new ExchangeAvailabilityModule({ ...args });
const exchangeAvailabilityModuleDefinition = {
    id: 'exchangeAvailability',
    type: 'module',
    factory: exchangeProvidersModuleFactory,
    dependencies: ['geolocationAtom', 'appProcessAtom?', 'exchangeAvailabilityAtom'],
};
export default exchangeAvailabilityModuleDefinition;
